import { ConfigProvider } from 'antd';
import { defaultTheme } from '@lib/themes';

import React, { PropsWithChildren } from 'react';

export const DefaultTheme: React.FC<PropsWithChildren> = ({ children }) =>
	<ConfigProvider theme={ defaultTheme }>{ children }</ConfigProvider>;
